import request from '@/utils/request'

//授权
export function authorization(data) {
    return request({
        url: `/File/GetAuthorization`,
        method: 'post',
        data
    })
}
//个人登录信息
export function loginInfo(data) {
    return request({
        url: `/Account/LoginInfo`,
        method: 'post',
        data
    })
}

//更改头像
export function updateMemberPhoto(data) {
    return request({
        url: `/Ucenter/UpdateMemberPhoto`,
        method: 'post',
        data
    })
}

//获取会员数据
export function getMemberInfo(data) {
    return request({
        url: `/Ucenter/GetMemberInfo`,
        method: 'post',
        data
    })
}

//获取区域列表
export function getRegionList(data) {
    return request({
        url: `/Ucenter/GetRegionList`,
        method: 'post',
        data
    })
}

//获取区域列表
export function getTreeRegionDataList(data) {
    return request({
        url: `/Ucenter/GetTreeRegionDataList`,
        method: 'post',
        data
    })
}

//获取会员内容数据
export function memberContentInfo(data) {
    return request({
        url: `/Ucenter/GetMemberContentInfo`,
        method: 'post',
        data
    })
}

//更改会员内容数据
export function updateMember(data) {
    return request({
        url: `/Ucenter/UpdateMember`,
        method: 'post',
        data
    })
}

//获取系统消息 
export function memberMessage(data) {
    return request({
        url: `/Ucenter/GetMemberMessage`,
        method: 'post',
        data
    })
}

//批量删除消息
export function batchDeleteMemberMessage(data) {
    return request({
        url: `/Ucenter/BatchDeleteMemberMessage`,
        method: 'post',
        data
    })
}

//批量删除消息
export function deleteAllMemberMessage(data) {
    return request({
        url: `/Ucenter/DeleteAllMemberMessage`,
        method: 'post',
        data
    })
}

//我的点赞
export function memberLikeMsgList(data) {
    return request({
        url: `/Ucenter/GetMemberLikeMsgList`,
        method: 'post',
        data
    })
}
//我的关注
export function memberFollowsList(data) {
    return request({
        url: `/Ucenter/GetMemberFollowsList`,
        method: 'post',
        data
    })
}

//我的粉丝
export function memberFansList(data) {
    return request({
        url: `/Ucenter/GetMemberFansList`,
        method: 'post',
        data
    })
}

//取消关注
export function unFollowMember(data) {
    return request({
        url: `/Member/UnFollowMember`,
        method: 'post',
        data
    })
}
//添加关注
export function followMember(data) {
    return request({
        url: `/Member/FollowMember`,
        method: 'post',
        data
    })
}


//获取我的点赞
export function likeContentMemberList(data) {
    return request({
        url: `/Ucenter/GetLikeContentMemberList`,
        method: 'post',
        data
    })
}

//清空全部
export function removeAllMemberLikes(data) {
    return request({
        url: `/Ucenter/RemoveAllMemberLikes`,
        method: 'post',
        data
    })
}

//多条删除
export function batchDeleteMemberLikes(data) {
    return request({
        url: `/Ucenter/BatchDeleteMemberLikes`,
        method: 'post',
        data
    })
}

//我的收藏
export function collectionMemberList(data) {
    return request({
        url: `/Ucenter/GetCollectionMemberList`,
        method: 'post',
        data
    })
}

//我的收藏 -清除全部
export function removeAllMemberCollection(data) {
    return request({
        url: `/Ucenter/RemoveAllMemberCollection`,
        method: 'post',
        data
    })
}
//我的收藏 -删除
export function batchDeleteMemberCollection(data) {
    return request({
        url: `/Ucenter/batchDeleteMemberCollection`,
        method: 'post',
        data
    })
}


//浏览历史
export function historyContentMemberList(data) {
    return request({
        url: `/Ucenter/GetHistoryContentMemberList`,
        method: 'post',
        data
    })
}

//浏览历史-清除全部
export function deleteAllMemberHistory(data) {
    return request({
        url: `/Ucenter/deleteAllMemberHistory`,
        method: 'post',
        data
    })
}
//浏览历史 -删除
export function batchDeleteMemberHistory(data) {
    return request({
        url: `/Ucenter/BatchDeleteMemberHistory`,
        method: 'post',
        data
    })
}

//获取我发出的评论
export function getMyPostComments(data) {
    return request({
        url: `/Ucenter/GetMyPostComments`,
        method: 'post',
        data
    })
}

//获取收到的评论--全部
export function getMyReceivedComment(data) {
    return request({
        url: `/Ucenter/GetMyReceivedComment`,
        method: 'post',
        data
    })
}
//获取收到的评论--未读
export function getMyReceivedUnReadComment(data) {
    return request({
        url: `/Ucenter/GetMyReceivedUnReadComment`,
        method: 'post',
        data
    })
}

//全部标记为已读
export function updateAllCommentRead(data) {
    return request({
        url: `/Ucenter/UpdateAllCommentRead`,
        method: 'post',
        data
    })
}


//单项删除
export function deleteMemberComment(data) {
    return request({
        url: `/Ucenter/DeleteMemberComment`,
        method: 'post',
        data
    })
}

//评论清空数据
export function deleteAllMyPostComment(data) {
    return request({
        url: `/Ucenter/DeleteAllMyPostComment`,
        method: 'post',
        data
    })
}

//确认回复评论
export function createReplyComment(data) {
    return request({
        url: `/Ucenter/CreateReplyComment`,
        method: 'post',
        data
    })
}

//屏蔽或取消屏蔽
export function updateCommentShieldStatus(data) {
    return request({
        url: `/Ucenter/UpdateCommentShieldStatus`,
        method: 'post',
        data
    })
}